module.exports = __webpack_public_path__ + "static/media/badge-percent.d3c234b7.svg";